import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { OfferSection } from '../components/OfferSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PriceBlock } from '../components/PriceBlock';
import { SectionDivider } from '../components/SectionDivider';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1584241515962496');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-zinc-950 text-zinc-300 font-sans selection:bg-gold-900 selection:text-gold-50" data-id="element-336">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-337">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1584241515962496&ev=PageView&noscript=1" alt="" data-id="element-338" />
      </noscript>

      {/* Sticky Top Banner */}
      <div className="sticky top-0 z-50 w-full bg-gold-gradient text-gold-950 font-bold text-center py-3 px-4 text-sm md:text-base shadow-[0_4px_20px_rgba(201,168,76,0.3)]" data-id="element-339">
        <span className="animate-pulse mr-2" data-id="element-340">🔥</span>
        LIMITED TIME: 82% OFF — Only $17 (Regular $97)
      </div>

      <main data-id="element-341">
        <HeroSection data-id="element-342" />
        <OpeningHook data-id="element-343" />
        <SectionDivider data-id="element-344" />
        <ProblemSection data-id="element-345" />
        <MechanismSection data-id="element-346" />
        <OfferSection data-id="element-347" />
        <SectionDivider data-id="element-348" />
        <AudienceSection data-id="element-349" />
        <HowItWorks data-id="element-350" />
        <ProofSection data-id="element-351" />
        <FAQSection data-id="element-352" />
        <PriceBlock data-id="element-353" />
      </main>

      <footer className="py-8 text-center border-t border-gold-900/20 bg-zinc-950" data-id="element-354">
        <div className="max-w-4xl mx-auto px-4" data-id="element-355">
          <p className="text-gold-600/60 text-sm font-mono mb-2 uppercase tracking-widest" data-id="element-356">
            © {new Date().getFullYear()} The Legacy of the Unbreakable Voice.
            All rights reserved.
          </p>
          <p className="text-zinc-600 text-xs max-w-2xl mx-auto" data-id="element-357">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}